import React, { useState } from "react";

// components
import FiltersContent from "../Filters/Filters.content";
import Navigation from "../Navigation/Navigation.content";
import PageShell from "../Navigation/PageShell";
import Layout from "../Layout/Layout.container";
import { ClassicViewBar } from "./Main.styles";
import { ClassicViewContext, readClassicView, saveClassicView } from "../../../config/classicView";
import { SessionReadyContext } from "../../../config/session";
import { ShowRangeContext } from "../../../config/showRange";
import { appliedFiltersCount, FilterStatusContext, filterStatuses, FilterValues, pendingFilters } from "../../../config/appliedFilters";

// types
import { DateRange } from "../../../types/common";
import { Origin } from "../../../types/origins";
import { Leader } from "../../../types/leaders";
import { Supervisor } from "../../../types/supervisors";
import { Seller } from "../../../types/sellers";
import { State } from "../../../types/states";
import { Channel } from "../../../types/channels";
import { Client } from "../../../types/clients";
import { OperationType } from "../../../types/operationTypes";

interface Props {
  pending?: boolean;
  // Axia V2 props
  isAxiaV2?: boolean;
  tracyUrl?: string | null;
  // Date Filters
  rangeDate: DateRange;
  setRangeDate: (rangeDate: DateRange) => void;
  // Business Filters
  idSourceFilter: string;
  setIdSourceFilter: (value: string) => void;
  originsSelected: Origin[];
  leadersSelected: Leader[];
  supervisorsSelected: Supervisor[];
  sellersSelected: Seller[];
  statesSelected: State[];
  channelsSelected: Channel[];
  clientsSelected: Client[];
  operationTypesSelected: OperationType[];
  setOriginsSelected: (param: Origin[]) => void;
  setLeadersSelected: (param: Leader[]) => void;
  setSupervisorsSelected: (param: Supervisor[]) => void;
  setSellersSelected: (param: Seller[]) => void;
  setStatesSelected: (param: State[]) => void;
  setChannelsSelected: (param: Channel[]) => void;
  setClientsSelected: (param: Client[]) => void;
  setOperationTypesSelected: (param: OperationType[]) => void;
  sendFilters: () => void;
  resetFilters: () => void;
  showRange: (range: DateRange) => void;
  discardFilters: () => void;
  presetRange: (range: DateRange) => void;
  appliedFilters: FilterValues;
  // data
  activeFilters: any;
  filtersChanged: boolean;
  reintentosQuantity: number;
  pendienteDescargaQuantity: number;
  setReintentosQuantity: (param: number) => void;
  setPendienteDescargaQuantity: (param: number) => void;
  ordersTotal: number;
  fetchingOrders: boolean;
  sellersTotal: number;
}

export default (props: Props) => {
  const [classic, setClassicState] = useState(readClassicView);
  const classicView = {
    classic,
    setClassic: (value: boolean) => {
      saveClassicView(value);
      setClassicState(value);
    },
  };

  // Si es Axia V2 y tenemos la URL, mostrar el iframe con el layout
  if (props.isAxiaV2 && props.tracyUrl) {
    return (
        <div>
          {!window.orders360Embedded && <Layout />}

          {/* Contenedor del iframe que respeta el layout */}
          <div style={{
            width: "100%",
            minHeight: "calc(100vh - 80px)", // Ajusta según la altura de tu Layout/navbar
            padding: "20px",
            backgroundColor: "#f5f5f5", // Fondo opcional
            boxSizing: "border-box"
          }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              overflow: "hidden",
              height: "calc(100vh - 140px)" // Ajusta según necesites
            }}>
              <iframe
                  src={props.tracyUrl}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none"
                  }}
                  title="Tracy Commerce Grid"
              />
            </div>
          </div>
        </div>
    );
  }

  const filters = (
      <FiltersContent
          // Date Filters
          rangeDate={props.rangeDate}
          setRangeDate={props.setRangeDate}
          // Business Filters
          idSourceFilter={props.idSourceFilter}
          setIdSourceFilter={props.setIdSourceFilter}
          originsSelected={props.originsSelected}
          leadersSelected={props.leadersSelected}
          supervisorsSelected={props.supervisorsSelected}
          sellersSelected={props.sellersSelected}
          statesSelected={props.statesSelected}
          channelsSelected={props.channelsSelected}
          clientsSelected={props.clientsSelected}
          operationTypesSelected={props.operationTypesSelected}
          setOriginsSelected={props.setOriginsSelected}
          setLeadersSelected={props.setLeadersSelected}
          setSupervisorsSelected={props.setSupervisorsSelected}
          setSellersSelected={props.setSellersSelected}
          setStatesSelected={props.setStatesSelected}
          setChannelsSelected={props.setChannelsSelected}
          setClientsSelected={props.setClientsSelected}
          setOperationTypesSelected={props.setOperationTypesSelected}
          sendFilters={props.sendFilters}
          resetFilters={props.resetFilters}
      />
  );

  // Renderizado normal cuando NO es Axia V2
  if (classic) {
    return (
        <ClassicViewContext.Provider value={classicView}>
          <div>
            {!window.orders360Embedded && <Layout />}

            <ClassicViewBar>
              <button type="button" className="k-button" data-cy="VistaNueva" onClick={() => classicView.setClassic(false)}>
                Ver la vista nueva
              </button>
            </ClassicViewBar>

            {filters}

            <Navigation
                //filters
                rangeDate={props.rangeDate}
                activeFilters={props.activeFilters}
                filtersChanged={props.filtersChanged}
                sendFilters={props.sendFilters}
                pendienteDescargaQuantity={props.pendienteDescargaQuantity}
                reintentosQuantity={props.reintentosQuantity}
                setPendienteDescargaQuantity={props.setPendienteDescargaQuantity}
                setReintentosQuantity={props.setReintentosQuantity}
            />
          </div>
        </ClassicViewContext.Provider>
    );
  }

  const pending = pendingFilters(props, props.appliedFilters);

  return (
      <ClassicViewContext.Provider value={classicView}>
        <SessionReadyContext.Provider value={!props.pending}>
          <ShowRangeContext.Provider value={props.showRange}>
            <FilterStatusContext.Provider value={filterStatuses(props.appliedFilters, pending)}>
              <div>
                {!window.orders360Embedded && <Layout />}

                <PageShell
                    rangeDate={props.appliedFilters.rangeDate}
                    activeFilters={props.activeFilters}
                    pendingFilters={pending.length}
                    sendFilters={props.sendFilters}
                    resetFilters={props.resetFilters}
                    discardFilters={props.discardFilters}
                    presetRange={props.presetRange}
                    activeFiltersCount={appliedFiltersCount(props.appliedFilters)}
                    filters={filters}
                    ordersTotal={props.ordersTotal}
                    fetchingOrders={props.fetchingOrders}
                    sellersTotal={props.sellersTotal}
                    pendienteDescargaQuantity={props.pendienteDescargaQuantity}
                    reintentosQuantity={props.reintentosQuantity}
                />
              </div>
            </FilterStatusContext.Provider>
          </ShowRangeContext.Provider>
        </SessionReadyContext.Provider>
      </ClassicViewContext.Provider>
  );
};
